import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import TpClientInvoiceJobLineSubTab from './TpClientInvoiceJobLineSubTab';
import TpClientInvoiceLineItemSubTab from './TpClientInvoiceLineItemSubTab';
import TpClientInvoiceLineItemAndJobLineTab from './TpClientInvoiceLineItemAndJobLineSubTab';
import TpEvaluatorTpJobPaymentSubTab from './TpEvaluatorTpJobPaymentSubTab';

export default class TpClientInvoiceDetailsDetailsTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  tabs = [
    {
      label: 'Assignments',
      id: 'assignments',
      icon: 'fa-solid fa-clipboard-list',
      component: <TpClientInvoiceJobLineSubTab tpClientInvoiceId={this.props.tpClientInvoiceId} />,
      key: 'invoice_assignments',
    },
    {
      label: 'Line Items',
      id: 'lineitems',
      icon: 'fa-solid fa-paperclip',
      component: <TpClientInvoiceLineItemSubTab tpClientInvoiceId={this.props.tpClientInvoiceId} />,
      key: 'invoice_lineitems',
    },
    {
      label: 'All',
      id: 'all',
      icon: 'fa-solid fa-book',
      component: <TpClientInvoiceLineItemAndJobLineTab tpClientInvoiceId={this.props.tpClientInvoiceId} />,
      key: 'invoice_all',
    },
    {
      label: 'Evaluator Payments',
      id: 'evaluatorpayments',
      icon: 'fa-solid fa-money-bill-wave',
      component: <TpEvaluatorTpJobPaymentSubTab tpClientInvoiceId={this.props.tpClientInvoiceId} />,
      key: 'invoice_evaluatorpayments',
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
